export default __webpack_public_path__ + "static/BioRhyme-Regular-kern-latin-c50ecd49ff76b32668b158081ae5af48.woff2";